import { NetworkClient, useClassFactory, useNetworkService } from "@pasta/box-v2";
import { type AgentsDirectoryAutocompleteItem } from "../dto/agents-directory.dto";

export class FavoriteUserApi {
  private baseEndpoint = "favorite-user/";

  protected get network(): NetworkClient {
    return useNetworkService();
  }

  async getMine(type: string): Promise<(AgentsDirectoryAutocompleteItem & { id: number })[]> {
    const result = await this.network.get<(AgentsDirectoryAutocompleteItem & { id: number })[]>(
      `${this.baseEndpoint}my/${type}`
    );
    return result.data;
  }

  async delete(id: number) {
    await this.network.delete(`${this.baseEndpoint}${id}`);
  }
}

export const [FavoriteUserApiToken, useFavoriteUserApi] = useClassFactory(FavoriteUserApi);
